<script lang="ts" setup>
  import { ElDrawer } from 'element-plus';
  import { computed, ref, useSlots } from 'vue';
  import { excludeObjectKeys } from '../../../utils';
  import { DrawerProps } from './drawer';

  defineOptions({
    name: 'IDrawer',
  });

  const props = defineProps(DrawerProps);
  const emit = defineEmits({
    'update:modelValue': (val: boolean) => val,
    openAutoFocus: () => true,
    closeAutoFocus: () => true,
    close: () => true,
    closed: () => true,
    open: () => true,
    opened: () => true,
  });

  const attrs = computed(() => excludeObjectKeys(props, ['hasScrollbar', 'overTop']));

  const slots = useSlots();
  const drawerRef = ref();

  defineExpose({
    getRef() {
      return drawerRef.value;
    },
  });
  const handleClose = () => {
    emit('update:modelValue', false);
    emit('close');
  };
</script>

<template>
  <ElDrawer
    ref="drawerRef"
    class="i-drawer"
    :class="{
      'i-drawer-over-top': !overTop,
    }"
    v-bind="attrs"
    @close="handleClose"
    @closed="emit('closed')"
    @open="emit('open')"
    @opened="emit('opened')"
    @close-auto-focus="emit('closeAutoFocus')"
    @open-auto-focus="emit('openAutoFocus')"
  >
    <!--  自定义header  -->
    <template v-if="slots.header">
      <slot name="header" />
    </template>
    <!--  默认header  -->
    <template v-if="!slots.header" #header="{ titleId, close }">
      <div :id="titleId" class="i-drawer-header">
        <div class="i-drawer-title">
          <div class="y-block-name">{{ title }}</div>
          <slot name="headerDesc" />
        </div>
        <div class="i-drawer-header-close" @click="close">
          <i class="iconfont icon-guanbi" />
        </div>
      </div>
    </template>
    <!--  内容  -->
    <div class="i-drawer-body" :class="{ 'i-drawer-no-footer': !slots.footer }">
      <ElScrollbar v-if="hasScrollbar" style="padding-right: 10px">
        <slot name="default" />
      </ElScrollbar>
      <slot v-else name="default" />
    </div>
    <div v-if="slots.footer" class="i-drawer-footer">
      <slot name="footer" />
    </div>
  </ElDrawer>
</template>
